import * as apiInterface from "@/api/apiInterface.js";

const actions = {
  getUserInfo({ key }, parm) {
    return new Promise((resolve, reject) => {
      apiInterface
        .getUserInfo(parm)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          console.log(key);
          reject(error);
        });
    });
  },
  GetAllCompany({ key }, parm) {
    return new Promise((resolve, reject) => {
      apiInterface
        .GetAllCompany(parm)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          console.log(key);
          reject(error);
        });
    });
  },
  EditSignUrl({ key }, parm) {
    return new Promise((resolve, reject) => {
      apiInterface
        .EditSignUrl(parm)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          console.log(key);
          reject(error);
        });
    });
  },
  getStudentType({ key }, parm) {
    return new Promise((resolve, reject) => {
      apiInterface
        .getStudentType(parm)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          console.log(key);
          reject(error);
        });
    });
  },
  GetSutentById({ key }, parm) {
    return new Promise((resolve, reject) => {
      apiInterface
        .GetSutentById(parm)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          console.log(key);
          reject(error);
        });
    });
  },
  AddVideoHistory({ key }, parm) {
    return new Promise((resolve, reject) => {
      apiInterface
        .AddVideoHistory(parm)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          console.log(key);
          reject(error);
        });
    });
  },
  VideoHistory({ key }, parm) {
    return new Promise((resolve, reject) => {
      apiInterface
        .VideoHistory(parm)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          console.log(key);
          reject(error);
        });
    });
  },
  AddVideoRecord({ key }, parm) {
    return new Promise((resolve, reject) => {
      apiInterface
        .AddVideoRecord(parm)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          console.log(key);
          reject(error);
        });
    });
  },
  StudentsAdd({ key }, parm) {
    return new Promise((resolve, reject) => {
      apiInterface
        .StudentsAdd(parm)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          console.log(key);
          reject(error);
        });
    });
  },
  StudentsEdit({ key }, parm) {
    return new Promise((resolve, reject) => {
      apiInterface
        .StudentsEdit(parm)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          console.log(key);
          reject(error);
        });
    });
  },
  CheckRepeat({ key }, parm) {
    return new Promise((resolve, reject) => {
      apiInterface
        .CheckRepeat(parm)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          console.log(key);
          reject(error);
        });
    });
  },
  GetFuntree({ key }, parm) {
    return new Promise((resolve, reject) => {
      apiInterface
        .GetFuntree(parm)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          console.log(key);
          reject(error);
        });
    });
  },
  GetFunTree2({ key }, parm) {
    return new Promise((resolve, reject) => {
      apiInterface
        .GetFunTree2(parm)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          console.log(key);
          reject(error);
        });
    });
  },
  GetUnitTree({ key }, parm) {
    return new Promise((resolve, reject) => {
      apiInterface
        .GetUnitTree(parm)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          console.log(key);
          reject(error);
        });
    });
  },
  getQuesID({ key }, parm) {
    return new Promise((resolve, reject) => {
      apiInterface
        .getQuesID(parm)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          console.log(key);
          reject(error);
        });
    });
  },
  getVideoM({ key }, parm) {
    return new Promise((resolve, reject) => {
      apiInterface
        .getVideoM(parm)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          console.log(key);
          reject(error);
        });
    });
  },
  getSimulatePaper({ key }, parm) {
    return new Promise((resolve, reject) => {
      apiInterface
        .getSimulatePaper(parm)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          console.log(key);
          reject(error);
        });
    });
  },

  getAllQuesconect({ key }, parm) {
    return new Promise((resolve, reject) => {
      apiInterface
        .getAllQuesconect(parm)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          console.log(key);
          reject(error);
        });
    });
  },

  checkPay({ key }, parm) {
    return new Promise((resolve, reject) => {
      apiInterface
        .checkPay(parm)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          console.log(key);
          reject(error);
        });
    });
  },

  trainstudents({ key }, parm) {
    return new Promise((resolve, reject) => {
      apiInterface
        .trainstudents(parm)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          console.log(key);
          reject(error);
        });
    });
  },

  SaveCuoTi({ key }, parm) {
    return new Promise((resolve, reject) => {
      apiInterface
        .SaveCuoTi(parm)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          console.log(key);
          reject(error);
        });
    });
  },

  SubmitSocre({ key }, parm) {
    return new Promise((resolve, reject) => {
      apiInterface
        .SubmitSocre(parm)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          console.log(key);
          reject(error);
        });
    });
  },
  OnlyTestUserSubmitSocre({ key }, parm) {
    return new Promise((resolve, reject) => {
      apiInterface
        .OnlyTestUserSubmitSocre(parm)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          console.log(key);
          reject(error);
        });
    });
  },
  GetGraduationByIdCard({ key }, parm) {
    return new Promise((resolve, reject) => {
      apiInterface
        .GetGraduationByIdCard(parm)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          console.log(key);
          reject(error);
        });
    });
  },
  GetPlanBySubjectID({ key }, parm) {
    return new Promise((resolve, reject) => {
      apiInterface
        .GetPlanBySubjectID(parm)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          console.log(key);
          reject(error);
        });
    });
  },

  getChart({ key }, parm) {
    return new Promise((resolve, reject) => {
      apiInterface
        .getChart(parm)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          console.log(key);
          reject(error);
        });
    });
  },

  getSelfDataList({ key }, parm) {
    return new Promise((resolve, reject) => {
      apiInterface
        .getSelfDataList(parm)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          console.log(key);
          reject(error);
        });
    });
  },

  saveSelfData({ key }, parm) {
    return new Promise((resolve, reject) => {
      apiInterface
        .saveSelfData(parm)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          console.log(key);
          reject(error);
        });
    });
  },

  getStudent({ key }, parm) {
    return new Promise((resolve, reject) => {
      apiInterface
        .getStudent(parm)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          console.log(key);
          reject(error);
        });
    });
  },

  saveStudent({ key }, parm) {
    return new Promise((resolve, reject) => {
      apiInterface
        .saveStudent(parm)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          console.log(key);
          reject(error);
        });
    });
  },

  getCuoTiList({ key }, parm) {
    return new Promise((resolve, reject) => {
      apiInterface
        .getCuoTiList(parm)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          console.log(key);
          reject(error);
        });
    });
  },

  getCuoTiDetail({ key }, parm) {
    return new Promise((resolve, reject) => {
      apiInterface
        .getCuoTiDetail(parm)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          console.log(key);
          reject(error);
        });
    });
  },

  getSysDictionary({ key }, parm) {
    return new Promise((resolve, reject) => {
      apiInterface
        .getSysDictionary(parm)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          console.log(key);
          reject(error);
        });
    });
  },

  getTrain({ key }, parm) {
    return new Promise((resolve, reject) => {
      apiInterface
        .getTrain(parm)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          console.log(key);
          reject(error);
        });
    });
  },

  GetStudentByOpenId({ key }, parm) {
    return new Promise((resolve, reject) => {
      apiInterface
        .GetStudentByOpenId(parm)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          console.log(key);
          reject(error);
        });
    });
  },

  getTrainList({ key }, parm) {
    return new Promise((resolve, reject) => {
      apiInterface
        .getTrainList(parm)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          console.log(key);
          reject(error);
        });
    });
  },

  getAnalysisZx({ key }, parm) {
    return new Promise((resolve, reject) => {
      apiInterface
        .getAnalysisZx(parm)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          console.log(key);
          reject(error);
        });
    });
  },
  getAnalysis({ key }, parm) {
    return new Promise((resolve, reject) => {
      apiInterface
        .getAnalysis(parm)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          console.log(key);
          reject(error);
        });
    });
  },
  GetTrainClass({ key }, parm) {
    return new Promise((resolve, reject) => {
      apiInterface
        .GetTrainClass(parm)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          console.log(key);
          reject(error);
        });
    });
  },
  GetBm({ key }, parm) {
    return new Promise((resolve, reject) => {
      apiInterface
        .GetBm(parm)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          console.log(key);
          reject(error);
        });
    });
  },
};

export default {
  namespaced: true,
  actions,
};
